import { all, call } from 'redux-saga/effects';
import userInfoSaga from 'redux/sagas/userInfo/userInfoSaga';
import serviceDeskSaga from 'redux/sagas/serviceDesk/serviceDeskSaga';
import myPinSaga from 'redux/sagas/setting/myPinSaga';
import integrationCategorySaga from 'redux/sagas/setting/integrationCategorySaga';
import changePhotoSaga from 'redux/sagas/changePhoto/changePhotoSaga';
import findPasswordSaga from 'redux/sagas/findPassword/findPasswordSaga';
import kmsSaga from 'redux/sagas/kms/kmsSaga';
import employeeInformationSaga from 'redux/sagas/personalInformation/employeeInformationSaga';
import passwordChangeSaga from 'redux/sagas/personalInformation/passwordChangeSaga';
import passwordHintSaga from 'redux/sagas/personalInformation/passwordHintSaga';
import idChangeSaga from 'redux/sagas/personalInformation/idChangeSaga';
import signupSaga from 'redux/sagas/signup/signupSaga';
import privacyPolicySaga from 'redux/sagas/privacyPolicy/privacyPolicySaga';
import landingSaga from 'redux/sagas/landing/landingSaga';
import passwordChangeForExchangeSaga from 'redux/sagas/passwordChangeForExchange/passwordChangeForExchangeSaga';
import passwordChangeForPPPSaga from 'redux/sagas/passwordChangeForPPP/passwordChangeForPPPSaga';

export default function* rootSaga() {
  try {
    yield all([
      call(userInfoSaga),
      call(serviceDeskSaga),
      call(myPinSaga),
      call(integrationCategorySaga),
      call(changePhotoSaga),
      call(findPasswordSaga),
      call(kmsSaga),
      call(employeeInformationSaga),
      call(passwordChangeSaga),
      call(passwordHintSaga),
      call(idChangeSaga),
      call(signupSaga),
      call(privacyPolicySaga),
      call(landingSaga),
      call(passwordChangeForExchangeSaga),
      call(passwordChangeForPPPSaga),
    ]);
  } catch (err) {
    // console.log(err);
  }
}
